import React from "react";
import { motion } from "framer-motion";
import { Flex, Text, Divider, Box } from "@chakra-ui/react";
import { StarIcon } from "@chakra-ui/icons"
import ProfileImg from "../assets/images/Profile.jpg";

const ListItem = ({ children }) => {
  return (
    <Flex alignItems="center">
      <StarIcon w={3} h={3} mr={2} color="primary.light" />
      <Text>{children}</Text>
    </Flex>
  )
}

const AboutSection = () => {
  return (
    <motion.div
      style={{
        width: "75%",
        marginTop: "5rem",
        paddingLeft: "6.5rem",
        paddingRight: "6.5rem"
      }}
      id="about"
    >
      <Flex
        justifyContent="flex-start"
        alignItems="center"
        mb="1.5rem"
        fontSize="1.5rem"
      >
        01.{" "}
        <Text
          pl="0.5rem"
          pr="1rem"
          fontSize="1.75rem"
          fontWeight="700"
          color="text.light"
          as={"span"}
        >
          About Me
        </Text>
        <Divider w="40%" opacity="0.3" />
      </Flex>
      <Flex alignItems="flex-start">
        <Box w="60%" fontSize="1.15rem">
          <Text color="text.dark" mb="1.5rem">
            A pre final year engineering student with sound knowledge of OOPS ,
            Data structures and Algorithms along with good problem solving
            kills. I have got hands on experience with programming languages
            like{" "}
            <Text as={"span"} color="primary.light">
              C/C++
            </Text>{" "}
            and{" "}
            <Text as={"span"} color="primary.light">
              Javascript
            </Text>
            .
          </Text>
          <Text color="text.dark" mb="1.5rem">
            I have been into{" "}
            <Text as={"span"} color="primary.light">
              Web development
            </Text>{" "}
            (MERN) and Javascript stuff for quite a while now.
            I have got experience in building pixel perfect web applications, component libraries,
            frontend architecture and stuff.
          </Text>
          <Text color="text.dark" mb="0.5rem">
            Some of the technologies, I do work with:
          </Text>
          <Flex>
            <Box mr={10}>
              <ListItem>HTML</ListItem>
              <ListItem>CSS</ListItem>
              <ListItem>Javascript</ListItem>
              <ListItem>React</ListItem>
              <ListItem>Redux</ListItem>
            </Box>
            <Box mr={10}>
              <ListItem>NextJS</ListItem>
              <ListItem>Material UI</ListItem>
              <ListItem>Chakra UI</ListItem>
              <ListItem>Tailwind CSS</ListItem>
              <ListItem>NodeJS</ListItem>
            </Box>
            <Box>
              <ListItem>Express</ListItem>
              <ListItem>MongoDB</ListItem>
              <ListItem>Firebase</ListItem>
            </Box>
          </Flex>
        </Box>
        <Flex
          w={270}
          h={322}
          borderRadius="0.25rem"
          position="relative"
          mt="1.5rem"
          ml="4.5rem"
          border="2px solid"
          borderColor="primary.light"
        >
          <Box
            w={270}
            h={322}
            position="absolute"
            top="-20px"
            left="-20px"
            borderRadius="0.25rem"
            backgroundImage={ProfileImg}
            backgroundSize="cover"
            backgroundColor="primary.light"
            backgroundBlendMode="luminosity"
            transition="all ease-in 0.2s"
            _hover={{
              backgroundBlendMode: "normal",
              top: "-15px",
              left: "-15px",
            }}
          ></Box>
        </Flex>
      </Flex>
    </motion.div>
  );
};

export default AboutSection;
